var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((_vm.sites),function(site){return _c('v-btn',{key:site.name,staticClass:"mx-4 white--text",attrs:{"icon":""}},[_c('a',{attrs:{"href":site.url}},[_c('v-icon',{attrs:{"size":"30px"}},[_vm._v(" "+_vm._s(site.icon)+" ")])],1)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }